import { WRENCH_MODE_SCHEDULES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/wrench_mode_schedules_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['wrenchModeSchedulesIndex', 'fieldTechWrenchModeSchedules', 'overviewWrenchModeSchedules']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
